import dynamic from "next/dynamic";
const CategoryPage = dynamic(() => import("@/screens/Category"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
import useIsMobile from "@/hooks/useIsMobile";
import ElectionLanding from "@/screens/FiveStateElection/ElectionLanding";
// import CategoryPage from "@/screens/Category";
// import PageLayout from "@/screens/Layout/PageLayout";

export default function Category({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  electionLiveData = null,
  faqData = null,
}) {
  const isMobileDevice = useIsMobile();
const staticContent = `देश के पांच प्रमुख राज्यों- पश्चिम बंगाल, असम, तमिलनाडु, केरल और केंद्र शासित प्रदेश पुडुचेरी में विधानसभा चुनावों का आधिकारिक ऐलान हो चुका है. इन चुनावों को 2029 के लोकसभा चुनाव से पहले का 'सेमीफाइनल' माना जा रहा है. अब सवाल ये है कि इन पांच राज्यों में चुनावी समीकरण क्या है? सवाल ये है कि पश्चिम बंगाल में ममता बनर्जी सत्ता बरकरार रख पाएंगी या भाजपा इस बार 'बड़ा खेला' करने में सफल होगी या वामदल चुनावी समीकरण बदल देंगे? असम में मुख्यमंत्री हेमंत बिस्वा सरमा के नेतृत्व पर जनता कितना भरोसा दिखाएगी, यह देखना दिलचस्प होगा.

तमिलानाडु में क्या विजय की पार्टी TVK (तमिलगा वेट्री कझगम) राज्य की राजनीति में बड़ा टर्निंग पॉइंट साबित होगी? केरल में वामपंथी दल (LDF) दोबारा सत्ता में वापसी का इतिहास दोहराएंगे? पुडुचेरी में NDA का जलवा होगा या कांग्रेस नेतृत्व वाला गठबंधन चौंकाएगा? इन सभी सवालों के जवाब और जनता का फैसला 4 मई 2026 को मतगणना के साथ सामने आएगा. मतदान की तारीखें नजदीक आ रही हैं और इसके साथ ही मतदाताओं के मन में कई सवाल भी हैं जिनका जवाब वे पाना चाहते हैं. ऐसे तमाम सवाल और उनके जवाब हमने F&Qs में शामिल किया है.`;
  return (
    <>
      <PageLayout
        rightSideBarData={categoryNewsListData}
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
        electionLiveData={electionLiveData}
      >
        <ElectionLanding
          categoryNewsListData={categoryNewsListData}
          isMobileDevice={isMobileDevice}
          electionLiveData={electionLiveData}
          faqData={faqData}
          masterKey="assembly_widgets_2026"
          staticContent={staticContent}
        />
      </PageLayout>
    </>
  );
}

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  try {
    let url = ctx?.resolvedUrl;
    //* remove query param from url
    url = url.split("?")[0];

    const { getDataByUrl, getNewUrlByOldSef } = await import(
      "@/handlers/commonApi"
    );
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
      const { getFaqBySlug } = await import("@/handlers/faq");
     const { getElectionVideoData } = await import("@/handlers/liveVideo");
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;
 
    //* get redis api key for each api
    let categoryListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: page,
        display: 12,
        type: "all",
      },
    });
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });
 let electionLiveRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: { api: "staticconfig", id: "home_livetv_config" },
    });
    let faqRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: { api: "staticpages", url: "bihar_election_faq" },
    });
    let [categoryNewsListData, { latestStoryData, latestVideoData },electionLiveData,faqData] =
      await Promise.all([
        fetchRedisWrapper(categoryListRedisKey, () =>
          getDataByUrl({
            url: url,
            page: page,
            display: 12,
            type: "all",
          })
        ),
        fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
         fetchRedisWrapper(electionLiveRedisKey, () => getElectionVideoData()),
         fetchRedisWrapper(faqRedisKey, () =>
        getFaqBySlug({
          url: "bihar_election_faq",
        })
      ),
      ]);

    if (
      !categoryNewsListData ||
      Object.keys(categoryNewsListData).length === 0
    ) {
      let sefUrl = ctx?.params?.category;
      console.log("##Find Article By SefURL##", sefUrl);
      const redirectUrlRedisKey = getRedisApiKey({
        redisPrefix: "PREFIX_REDIS_ROS",
        params: {
          api: "getnewurl",
          sefUrl: sefUrl,
        },
      });
      let responseData = await fetchRedisWrapper(redirectUrlRedisKey, () =>
        getNewUrlByOldSef({ sefUrl })
      );
      // console.log("res", responseData);
      if (responseData?.url) {
        let url = new URL(responseData.url); //? extract pathname from url with query params from url
        let pathname = url.pathname;

        let headerCache = responseData?.cache;
        setPageTTL(ctx, headerCache?.akamai_ttl);
        return {
          redirect: {
            destination: `${process.env.NEXT_PUBLIC_WEBSITE_URL}` + pathname,
            statusCode: 301,
          },
        };
      } else {
        return {
          notFound: true,
        };
      }
    }

    let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, headerCache?.akamai_ttl);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        electionLiveData,
          faqData: faqData || null,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
